import { motion } from "framer-motion";
import SEO from "@/components/SEO";
import { Reveal } from "@/components/Reveal";
import { PageHero, PrimaryLink, Overline } from "@/components/site";
import { FRAMEWORK, COMPANY } from "@/data/content";

export default function HowWeWork() {
  return (
    <div data-testid="page-how-we-work">
      <SEO title="How We Work — The TWORAY Advisory Framework"
        description="The TWORAY advisory framework: Assess, Advise, Plan, Enable — with Discover before and Assure after. Advice first, implementation where scoped." />
      <PageHero overline="How We Work" title="The TWORAY Advisory Framework."
        subtitle="Four core stages — Assess, Advise, Plan, Enable — with Discover before engagement and Assure afterwards. Advice first; implementation where it adds value and is explicitly scoped." />

      <section className="py-20 sm:py-28">
        <div className="mx-auto max-w-4xl px-5 sm:px-8">
          {/* Discover */}
          <Reveal>
            <div className="rounded-md border border-brandborder bg-lightbg p-7">
              <span className="text-xs font-semibold tracking-[0.2em] uppercase text-slate">Before engagement</span>
              <h3 className="mt-2 font-heading font-bold text-2xl text-navy">{FRAMEWORK.discover.title}</h3>
              <p className="mt-2 text-slate leading-relaxed">{FRAMEWORK.discover.desc}</p>
            </div>
          </Reveal>

          <div className="flex justify-center my-6"><div className="w-px h-8 bg-brandborder" /></div>

          {/* Core framework */}
          <Reveal>
            <div className="text-center mb-8"><Overline>The TWORAY Advisory Framework</Overline></div>
          </Reveal>
          <div className="relative">
            <div className="absolute left-[27px] top-2 bottom-2 w-px bg-brandborder hidden sm:block" />
            <div className="space-y-8">
              {FRAMEWORK.core.map((s, i) => (
                <Reveal key={s.num} delay={i * 0.05}>
                  <div className="relative flex gap-6 sm:gap-10 items-start">
                    <motion.div className="shrink-0 w-14 h-14 rounded-full bg-brand-gradient text-white grid place-items-center font-heading font-bold text-lg relative z-10" whileHover={{ scale: 1.06 }}>{s.num}</motion.div>
                    <div className="pt-1.5">
                      <h3 className="font-heading font-bold text-2xl text-navy">{s.title}</h3>
                      <p className="mt-2 text-slate leading-relaxed text-lg">{s.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <div className="flex justify-center my-6"><div className="w-px h-8 bg-brandborder" /></div>

          {/* Assure */}
          <Reveal>
            <div className="rounded-md border border-brandborder bg-lightbg p-7">
              <span className="text-xs font-semibold tracking-[0.2em] uppercase text-slate">After engagement</span>
              <h3 className="mt-2 font-heading font-bold text-2xl text-navy">{FRAMEWORK.assure.title}</h3>
              <p className="mt-2 text-slate leading-relaxed">{FRAMEWORK.assure.desc}</p>
            </div>
          </Reveal>

          <Reveal>
            <div className="mt-14 text-center">
              <p className="text-slate">{COMPANY.principle}</p>
              <PrimaryLink to="/book" className="mt-6" data-testid="how-book-cta">Book a Discovery Call</PrimaryLink>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
